import styled from "styled-components";

import { windowWidth } from "@styles/global";

const KanbanBasicCardContainer = styled.div`
  border-radius: 5px;
  padding: 0px 10px;
  height: 99px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 25%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media (min-width: ${windowWidth.tablet}) {
    cursor: pointer;
  }
`;

export { KanbanBasicCardContainer };
